import { useRef, useEffect } from 'react'

type UseClickOutsideReturn<T extends HTMLElement> = [
    React.RefObject<T>,
    (isOpen: boolean) => void
]

function useClickOutside<T extends HTMLElement = HTMLDivElement>(
    callback: () => void
): UseClickOutsideReturn<T> {
    const ref = useRef<T>(null)

    const handleClickOutside = (isOpen: boolean) => {
        useEffect(() => {
            const handleClick = (event: MouseEvent) => {
                if (ref.current && !ref.current.contains(event.target as Node)) {
                    callback()
                }
            }

            if (isOpen) {
                document.addEventListener('mousedown', handleClick)
            }

            return () => {
                document.removeEventListener('mousedown', handleClick)
            }
        }, [isOpen])
    }

    return [ref, handleClickOutside]
}

export default useClickOutside